module.exports = __webpack_public_path__ + "images/psp/ATV/atv-hero-size.png";